<template>
  <div>
    <div v-if="debug_show_page_name == true" style="color: green">
      page_0040_certificate_software_detail
    </div>
    <app-header>esma</app-header>
    <div :class="'container ' + pageContainerSize">

      <div v-if="showSurplusAlertMessage" class="col-xs-12 surplus_msg">
          以下のソフトウェア情報は余剰ライセンスです。<br>
          割当を希望される場合、[編集]ボタンより[所管区分][所管部署][所管チーム][所管システム(IT所管システムの場合)][申請者名（ﾌﾙﾈｰﾑ）][管理担当者名（ﾌﾙﾈｰﾑ）]欄を記入し、[申請]ボタンより申請を行ってください。<br>
          ※ライセンス数は変更できません。
        </div>
      <title-and-slot v-if="loadBy == 'deposit_certificate_output'" title="預り証出力（詳細）"> </title-and-slot>
      <title-and-slot v-else title="証書情報（詳細）"> </title-and-slot>

      <div class="row" style="margin-bottom: 10px">
        <div class="col-xs-4">
          <button
            class="btn btn-primary"
            style="
              width: 25%;
              float: left;
              margin-left: -25px;
              min-width: 100px;
            "
            @click="backToList"
          > ＜　戻る</button>
        </div>
        <div class="col-xs-8">
          <div
            style="
              width: 180px;
              float: right;
              font-size: 12px;
              text-align: right;
            "
          >
            更新日：{{ updateDate }}
          </div>
          <div
            style="
              width: 180px;
              float: right;
              font-size: 12px;
              text-align: right;
            "
          >
            登録日：{{ registrationDate }}
          </div>
        </div>

        <div class="col-xs-12">
          <div
            style="float: right; font-size: 10px; text-align: right; color: red"
          >
            ＊入力必須項目
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 10px">
        承認状態：
        <input
          :disabled="true"
          style="
            border: solid #337ab7 1px;
            width: 90px;
            padding-left: 4px;
            margin: 2px;
            border-radius: 5px;
            background-color: #e2ecf5;
            font-size: 12px;
          "
          :value="approvalStatus"
        />
        状態:
        <select
          :disabled="readOnly"
          :value="Status"
          @change="Status = $event.target.value"
          class="status_field"
          :style="statusFieldStyle"
        >
          <option
            v-for="option in StatusOptions"
            :selected="option == Status"
            :key="option"
            :value="option"
          >{{ option }}</option>
        </select>
        申請No：
        <input
          type="button"
          style="
            border: solid #337ab7 1px;
            width: 140px;
            padding-left: 4px;
            margin: 2px;
            margin-bottom: -6px;
            border-radius: 5px;
            background-color: #e2ecf5;
            font-size: 12px;
            color: #008cff;
            text-decoration: underline;
          "
          :value="approvalHistoryTorokuNumber"
          @click="onConfirmExecuteProcessConfirmation"
        />
        <span
          v-if="showApprovalHistoryBulkTorokuNumberQty"
          style="color:red;" >※この申請は一括申請です。同一の申請が {{approvalHistoryBulkTorokuNumberQty}} 件あります。</span>
      </div>
      <div class="row" style="margin-bottom: 10px">
          <div class="col-xs-12" style="padding: 0px;    margin: -15px;">
            <h3>ソフトウェア情報</h3>
          </div>
      </div>
      <div class="row" style="margin-bottom: 10px">
        <div class="row" style="margin-bottom: 10px">
          <div class="col-xs-6" style="">
            <!-- Coll A<br> -->
            <field-box
              v-for="f in formFields.col1"
              v-bind:key="f.id"
              v-bind:data="f"
              :read="readOnly"
              :val="values[f.id]"
            ></field-box>

          </div>
          <div class="col-xs-6" style="">
            <field-box
              v-for="f in formFields.col2"
              v-bind:key="f.id"
              v-bind:data="f"
              :read="readOnly"
              :val="values[f.id]"
            ></field-box>
            <field-box   
              v-for="f in formFields.col2b" 
              v-bind:key="f.id"
              v-bind:data="f"
              :read="readOnly"
              :val="values[f.id]"
              :option="{rows:2}"
            ></field-box>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 10px">
        <button
          v-show="draftWriteMode == false"
          v-if="read_only == false"
          :disabled="disableAllButtons ||checkUserPermission(true, permissionMode.EDIT) == false"
          class="btn btn-primary on_local_save_certificate_software"
          @click="onLocalUpSaveCertificateSoftware"
        >上書保存</button>
        <button
          v-show="draftWriteMode == true"
          v-if="read_only == false"
          :disabled="disableAllButtons ||checkUserPermission(true, permissionMode.EDIT) == false"
          class="btn btn-primary on_local_save_certificate_software"
          @click="onLocalSaveCertificateSoftware"
        >下書保存</button>
        <button
          v-if="read_only == false"
          :disabled="false"
          class="btn btn-primary btn_cancel_btn"
          @click="btnCancel"
        >ｷｬﾝｾﾙ</button>
        <button
          v-else
          v-show="hideEditMainBtn == false && approvalcancelmode == false"
          :disabled="disableAllButtons || disableEditMainBtn || checkUserPermission(true, permissionMode.EDIT) == false"
          class="btn btn-primary on_edit_btn"
          @click="onEdit"
        >編集</button>
              <button
              v-show ="hideApplyConfirmationBtn == false && approvalcancelmode == false"  @click="processApprovalApprove()"
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #92D050;border-color:#92D050;">確認</button>

              <button
              v-show ="hideApplyRejectBtn == false && hideApplyConfirmationBtn == true &&  approvalcancelmode == false "   @click="onapprovalSaveDevEmbeddedReason"
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #FF7C80;border-color:#FF7C80;">取戻</button>

              <button
              v-show ="hideApplyConfirmationBtn == false && approvalcancelmode == false"  @click="processApprovalCancel"
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #FF7C80;border-color:#FF7C80;">差戻</button>
        <button
          v-show="hideApplicationBtn == false && approvalcancelmode == false"
          :disabled="disableAllButtons  ||disableApplicationBtn || read_only == false ||checkUserPermission(true, permissionMode.EDIT) == false"
          class="btn btn-primary on_confirm_execute_process_btn"
          @click="onConfirmExecuteProcess"
        >申請</button>
        <button
          v-show="hideCopyMainBtn == false && approvalcancelmode == false"
          :disabled="disableAllButtons || forceDisableDueUpgradeDestination ||checkUserPermission(true, permissionMode.ADD) == false"
          class="btn btn-primary clone_record_btn"
          @click="cloneRecord"
        >
          コピー
        </button>
        <button class="btn btn-warning show_device_btn"
        v-show="approvalcancelmode == false"
        :disabled="isSurplus  || forceDisableDueUpgradeDestination || read_only == false ||  checkUserPermission(true, permissionMode.EDIT) == false || loadBy == 'deposit_certificate_output'"
        @click="onLinkDevice"
        >機器</button>
        <button
          v-show="approvalcancelmode == false"
          :disabled="disableAllButtons || checkUserPermission(true, permissionMode.BROWSE) == false"
          v-if="is_new == false"
          class="btn btn-primary show_history_btn"
          @click="showHistory"
        >更新履歴</button>
        <!--<button :disabled="checkUserPermission(true,permissionMode.DELETE) == false" v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">新規</button>
              -->
        <button 
          v-if="approvalcancelmode == true" 
          :disabled="false" class="btn btn-primary" 
          style="min-width:100px;width: 7%;float: right;margin-right: -10px;background: #A6A6A6;" 
          @click="approvalCancelbtn" >ｷｬﾝｾﾙ</button>
        <button
          v-if="approvalcancelmode == true"
          class="btn btn-primary" 
          style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #FF7C80;;background: #337ab7;" 
          @click="onapprovalSaveDevEmbedded" >入力完了</button>
          <span v-show="approvalcancelmode == true">
            <span style='float: right;
                         font-size: 15px;
                         margin-right: -190px;
                         font-weight: 800;
                         margin-top:-23px;
                         letter-spacing: 1px;
                         color:red;'
              >※差戻通知を入力し、入力完了をクリックして下さい。(任意)
            </span>
          </span>
      </div>

      <certificate-sub-page :controller="subTableController" :disable_pdf_btn = "disablepdfButtons"/>
    </div>
    <confirmation-modal
      tag="confirmDeviceEmbeddedInformationUpAddCheck"
      @done="onDeviceEmbeddedInformationUpAddCheckConfirm"
    />
    <confirmation-modal
      tag="confirmDeviceEmbeddedInformationAddcancel"
      @done="processApprovalCancelBack"
    />
    <confirmation-modal
      tag="confirmDeviceEmbeddedInformationAddcancelReason"
      @done="processApprovalCancelBackReason"
    />
    <certificate-information-connection-application-modal
      tag="showBulkImportConfimationModal"
    />
    <confirmation-modal
      tag="confirmUnlinkDevices"
      @done="onConfirmUnlinkDevices"
    />
    <confirmation-modal
      tag="confirmDeviceEmbeddedInformationAddCheck"
      @done="onDeviceEmbeddedInformationAddCheckConfirm"
    />

    <confirmation-modal
      tag="notificationAfterSave"
      @done="afterTheNotificationAfterSave"
    />
    <confirmation-modal
      tag="notificationAfterCertificateSoftwareApprovalStartedRequest"
      @done="afterTheNotificationAftercancel"
    />
    <application-confirmation-modal
      tag="certificateApplicationConfimationModal"
    />
    <change-history v-if="enableHistoryModal" tag="showCertificateSoftwareChangeHistoryModal" id_label="証書管理番号" />

    <certificate-software-linked-upgrade-modal  tag="showCertificateSoftwareLinkedUpgradeModal" @selected="onSelectedUpgradeCertificate" />
    <confirmation-modal
      tag="deleteCertificateInformationDetailModal"
      @done="onConfirmDelete"
    />
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { fields, filed_types } from "@/rules/fields_certificate_software";
import bulkImportConfirmationModal from "@/components/modals/certificate-information-connection-application-modal";
import applicationConfirmationModal from "@/components/modals/application-confirmation-modal";
import { utils } from "@/libs/utils";
import _debug from "debug";
var mdebug = _debug("esma:device_certificate_software");
import fieldBoxes from "@/components/form-field";
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";

import changeHistoryModal from "@/components/modals/change-history-modal";
import certificateSoftwareLinkedUpgradeModal from "@/components/modals/certificate-software-linked-upgrade-modal";


import certificateSubPage from "@/components/sub_pages/certificate";
import constants from "@/rules/constants";

var timeout_control = {};
var queue_bus = []

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "field-box": fieldBoxes,
    "certificate-information-connection-application-modal": bulkImportConfirmationModal,
    "application-confirmation-modal": applicationConfirmationModal,
    "change-history": changeHistoryModal,
    "certificate-sub-page":certificateSubPage,
    'certificate-software-linked-upgrade-modal':certificateSoftwareLinkedUpgradeModal
  },
  data() {
    return {
      show_sub_table_associated_device: false,
      api_name: "certificate_software",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      page_acl: acl.certificate_software,
      approval_history_id: "",
      approval_id: null,
      local_status: false,
      save_edit_cliqued: false,
      local_seq_id: -1,
      approval_history_toroku_number: false,
      sub_table_controller :{},
      allow_surplus:false,
      is_surplus:false,
      is_approved:false,
      load_upgrade_modal :false,
      force_disable_due_upgrade_destination:false,
      form_confirmation:{},
      enable_history_modal:false,
      show_surplus_alert_message:false,
      company_selection_started:false,
      approvalcancel_mode:false,
      hide_approval_cancel_field:true,
      approval_id:null,
      disable_edit:false,
      approval_history_bulk_toroku_number_qty:0,
      show_approval_history_bulk_toroku_number_qty:false,
      fields_validation_is_disabled:false,
      original_status:false,
      is_expired:false
    };
  },
  computed: {
    isExpired:{
      get(){
        return this.is_expired;
      },
      set(v){
        this.is_expired = v;
      }
    },
    showApprovalHistoryBulkTorokuNumberQty(){
      return this.approvalHistoryBulkTorokuNumberQty > 0 && this.loadBy == 'fk_id';
    },
    approvalHistoryBulkTorokuNumberQty:{
      get(){
        return this.approval_history_bulk_toroku_number_qty;
      },
      set(v){
        this.approval_history_bulk_toroku_number_qty = v;
      }
    },
    DisabledEdit:{
      get(){
        return this.disable_edit;
      },
      set(v){
        this.disable_edit = v;
      }
    },
    deleteBtnDisabled(){
      if(this.isApproverUserId == true){
        return false;
      }
    },
    approvalcancelmode:{
      get(){
        return this.approvalcancel_mode;
      },
      set(v){
        this.approvalcancel_mode = v;
      }
    },
    showSurplusAlertMessage:{
      get(){
        return this.show_surplus_alert_message;
      },
      set(v){
        this.show_surplus_alert_message = v;
      }
    },
    enableHistoryModal:{
      get(){
        return this.enable_history_modal;
      },
      set(v){
        this.enable_history_modal = v;
      }
    },
    forceDisableDueUpgradeDestination:{
      get(){
        return this.force_disable_due_upgrade_destination;
      },
      set(v){
        this.force_disable_due_upgrade_destination = v;
      }
    },
    loadUpgradeModal:{
      get(){
        return this.load_upgrade_modal;
      },
      set(v){
        this.load_upgrade_modal = v;
      }
    },
    statusFieldStyle(){
      if(this.$store.state["current_field_style"] && this.$store.state["current_field_style"]["status"]){
        return this.$store.state["current_field_style"]["status"];
      }else{
        return ""
      }
    },
    isApproved:{
      get(){
        return this.is_approved;
      },
      set(v){
        this.is_approved = v;
      }
    },
    isSurplus:{
      get(){
        return this.is_surplus;
      },
      set(v){
        this.is_surplus = v;
      }
    },
    allowSurplus:{
      get(){
        return this.allow_surplus;
      },
      set(v){
        this.allow_surplus = v;
      }
    },
    subTableController:{
      get(){
        return this.sub_table_controller;
      },
      set(v){
        this.sub_table_controller = v;
      }
    },
    disableAllButtons() {
      return this.loadBy == "certificate_software_number" || this.loadBy == "deposit_certificate_output";
    },
    disablepdfButtons(){
      if(this.$store.state[this.stateCurrentRow].status == "余剰"){
        if(!(Vue.localStorage.get("userRole")== constants.PERMISSION.SYSTEM_ADMINISTRATOR || Vue.localStorage.get("userRole") == constants.PERMISSION.MAINTENANCE_STAFF)){
          return true;
        }
      }
      return false;
    },
    localSeqId: {
      get() {
        return this.local_seq_id;
      },
      set(v) {
        this.local_seq_id = v;
      },
    },
    // About to hide or show the buttons start
    disableEditMainBtn() {
      //編集 (edit main)
      if (this.loadBy == "fk_id") {
        return this.hideForApplicant && this.approvalStatus == "申請中";
      }
      return this.approvalStatus == "申請中";
    },

    disableCopyMainBtn() {
      //コピー
      return false; // There is no condition to hide Copy
    },
    disableApplicationBtn() {
      //申請/Application
      return this.approvalStatus != "下書中";
    },
    draftWriteMode(){
      return this.loadBy != "fk_id";
    },
    hideForApplicant() {
      if (this.loadBy != "fk_id") {
        return false;
      }
      if (
        typeof this.$store.state[this.stateCurrentRow][
          "approval_history_next_approver"
        ] == "undefined" &&
        this.isAdmin == true
      ) {
        return false;
      } else {
        //                                               user is the applicant                                     and            user is not the next approver the  hide
        return (
          this.$store.state[this.stateCurrentRow][
            "approval_history_applicant"
          ] == Vue.localStorage.get("userID") &&
          this.$store.state[this.stateCurrentRow][
            "approval_history_next_approver"
          ] != Vue.localStorage.get("userID")
        );
      }
    },
    hideApprovalcancel(){
      this.hide_approval_cancel_field = (
        (this.retractionreason == "") 
      );
      this.hideApprovalCancelSet(this.hide_approval_cancel_field);
      //TODO:差戻 indication condition      
      if(this.loadBy != "fk_id" || this.approvalStatus != "申請中"){
        return true;
      }else{
        return false
      }
    },
    hideEditMainBtn() {
      // 編集 (edit main)
      return this.hideForApplicant &&  this.approvalStatus == "申請中";
    },

    hideCopyMainBtn() {
      //コピー
      return this.loadBy == "fk_id" || this.is_new == true;
    },
    hideApplicationBtn() {
      //申請/Application
      return (this.loadBy == "fk_id" && this.approvalStatus != "下書中") || this.approvalStatus != "下書中";
    },
    hideApplyConfirmationBtn() {
      //確認/Confirmation
      if (this.loadBy != "fk_id") {
        return true;
      }
      return this.hideForApplicant || this.approvalStatus != "申請中";
    },
    hideApplyRejectBtn() {
      //差戻/Reject
      //this.loadBy == 'fk_id'
      return this.hideApprovalcancel;
    },
    // About to hide or show the buttons end
    Deadline_Alert: {
      // FIXME: This fields are not goog, it is used as copy and paster, but there are a log or unecessary code
      get() {
        if (this.local_status === false) {
          return (
            this.$store.state[this.stateCurrentEditing]["deadline_alert"] || ""
          );
        } else {
          return this.local_status;
        }
      },
      set(v) {
        this.$store.state[this.stateCurrentRow][
          "deadline_alert"
        ] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing][
          "deadline_alert"
        ] = this.local_status = v;
      },
    },
    Comprehensive_contract: {
      get() {
        if (this.local_status === false) {
          return (
            this.$store.state[this.stateCurrentEditing][
              "comprehensive_contract"
            ] || ""
          );
        } else {
          return this.local_status;
        }
      },
      set(v) {
        this.$store.state[this.stateCurrentRow][
          "comprehensive_contract"
        ] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing][
          "comprehensive_contract"
        ] = this.local_status = v;
      },
    },
    Downgrade: {
      get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["downgrade"] || "";
        } else {
          return this.local_status;
        }
      },
      set(v) {
        this.$store.state[this.stateCurrentRow][
          "downgrade"
        ] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing][
          "downgrade"
        ] = this.local_status = v;
      },
    },
    Status: {
      get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        } else {
          return this.local_status;
        }
      },
      set(v) {
        if((this.isSurplus && this.$store.state[this.stateCurrentRow][ "status" ] == "余剰") && v == "廃棄"){
          this.disableValidation(true);
        }else if((this.original_status == "廃棄" || this.$store.state[this.stateCurrentRow][ "status" ] == "廃棄") && v == "使用中" ){
          this.disableValidation(false)
        }
        this.$store.state[this.stateCurrentRow][ "status" ] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing][ "status" ] = this.local_status = v;
      },
    },
    StatusOptions() {
      var options = _.clone(fields.status.options)
      if(this.allowSurplus == true){
        if(options.indexOf("余剰") < 0){
          options.push("余剰")
        }
      }
      return options;
    },

    subTableDeviceEmbeddedInformationStyle() {
      if (this.saveEditClicked || this.is_new == false) {
        return "";
      } else {
        return "opacity: 0.5;";
      }
    },
    saveEditClicked: {
      get() {
        return this.save_edit_cliqued;
      },
      set(v) {
        this.save_edit_cliqued = v;
      },
    },
    approvalHistoryId: {
      get() {
        return this.approval_history_id;
      },
      set(v) {
        this.approval_history_id = v;
      },
    },
    approvalHistoryTorokuNumber: {
      get() {
        return this.approval_history_toroku_number;
      },
      set(v) {
        this.approval_history_toroku_number = v;
      },
    },
    isAdminSavingApplication() {
      return this.isAdmin && this.loadBy == "fk_id";
    },
    showFieldchangedStyle() {
      return (
        (this.$store.state[this.stateCurrentRow]["approval_status"] ==
          "申請中" ||
          this.$store.state[this.stateCurrentRow]["approval_status"] ==
            "差戻") &&
        (this.isAdmin ||
          this.$store.state[this.stateCurrentRow][
            "approval_history_next_approver"
          ])
      );
    },
    approvalStatus() {
      return (
        this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"]
      );
    },
    retractionreason(){
      if(this.$store.state[this.stateCurrentRow]["retraction_reason"] != null){
        return this.$store.state[this.stateCurrentRow]["retraction_reason"];
      }else{
        return ""
      }
    },
    allowEditjurisdictionSystem() {
      return (
        this.$store.state[this.stateCurrentRow][
          "jurisdiction_classification"
        ] != "IT所管システム"
      );
    },
    approvalId: {
      get() {
        return this.approval_id;
      },
      set(v) {
        this.approval_id = v;
      },
    },
    certificateSoftwareNumber() {
      return this.$store.state[this.stateCurrentRow][
        "certificate_software_number"
      ];
    },

    certificateSeqId() {
      return parseInt(
        this.$store.state[this.stateCurrentRow]["seq_id"] || this.localSeqId
      );
    },
    showapprovalStatus (){
      return (this.$store.state[this.stateCurrentRow]["approval_status"] == "承認済")
    },
    deviceControlNumber() {
      return this.$store.state[this.stateCurrentRow]["device_control_number"];
    },
    updateDate() {
      if(this.$store.state[this.stateCurrentRow]["last_update_date"]){
        return utils.format_date(
        this.$store.state[this.stateCurrentRow]["last_update_date"]
      );
      }else{
        return "-"
      }
    },
    registrationDate() {
      return utils.format_date(
        this.$store.state[this.stateCurrentRow]["registration_date"]
      );
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1: [
          utils.extend(fields.certificate_software_number, {
            disabled: true,
            read_only: true,
          }),
          utils.extend(fields.maker, {disabled:this.DisabledEdit,read_only:this.DisabledEdit || this.forceDisableDueUpgradeDestination}),
          utils.extend(fields.software_name, {disabled:this.DisabledEdit,read_only:this.DisabledEdit || this.forceDisableDueUpgradeDestination}),

          utils.extend(fields.company, {disabled:this.DisabledEdit,read_only:this.DisabledEdit || this.forceDisableDueUpgradeDestination}),
          utils.extend(fields.licensed_department, {}), // EDITABLE ON UPGRADE
          utils.extend(fields.license_jurisdiction_team, {}), // EDITABLE ON UPGRADE
          utils.extend(fields.license_name, {disabled:this.DisabledEdit,read_only:this.DisabledEdit || this.forceDisableDueUpgradeDestination}),
          utils.extend(fields.jurisdiction_classification, {  // EDITABLE ON UPGRADE
            on_set_value: (data) => {
              this.singleTimeout("upd_license_jurisdiction_system_it", setTimeout(() => {
                this.queuedBusEmit("upd_license_jurisdiction_system_it", {
                  val: data == "IT所管システム",
                });
              }, 500));
              setTimeout(() => {
                this.queuedBusEmit("upd_license_jurisdiction_system", {
                  val: data == "EUC・その他",
                });
              }, 100);
            },
          }),
          utils.extend(fields.license_jurisdiction_system, { // EDITABLE ON UPGRADE
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;",
            listen_for: [
              {
                name: "upd_license_jurisdiction_system_it",
                mode: "disable_and_clean_if_value",
                disable_if_value: true,
              },
            ],
          }),
          utils.extend(fields.equipment_in_charge_system, {  // EDITABLE ON UPGRADE
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;",
            listen_for: [
              {
                name: "upd_license_jurisdiction_system",
                mode: "disable_and_clean_if_value",
                disable_if_value: true,
              },
            ],
          }),
          utils.extend(fields.product_key, {disabled:this.DisabledEdit,read_only:this.DisabledEdit}),  // EDITABLE ON UPGRADE
          utils.extend(fields.upgrade, {
            disabled:this.isSurplus,read_only:this.isSurplus  || this.forceDisableDueUpgradeDestination ,
            on_set_value:(data) =>{
              setTimeout(() => {
                this.queuedBusEmit("upd_upgrade",{val: data == "有"})
              }, 100);
            }
          }),
          utils.extend(fields.upgrade_source, {
            disabled:this.isSurplus,read_only:this.isSurplus  || this.forceDisableDueUpgradeDestination,
            force_readonly:true,
            // disabled: false,
            // required: true,
            field_style: " width: 100%;display: block;" ,
            buttons: [
              {
                  btn_style:"width:250px;margin-left:2px;padding-left: 1px;padding-right: 1px;float:left; margin-top: 2px;margin-bottom: 10px;    background: rgb(51 122 183);border-color: rgb(46 109 164);",
                  type:"callback",
                  callback:(b)=>{
                    this.selectUpgradeCertificate()
                  },
                  label:"アップグレード元の証書を選択する"// Need the spec.
              }
          ],
            listen_for: [
              {
                name: "upd_upgrade",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
          }),
        ],
        col2: [
          utils.extend(fields.upgrade_destination, {disabled:true,read_only:true}),
          utils.extend(fields.deadline_alert, {
            disabled:this.isSurplus,read_only:this.isSurplus  || this.forceDisableDueUpgradeDestination,
             on_set_value:(data) =>{
              setTimeout(() => {
                this.queuedBusEmit("upd_expiration_date",{val: data == "有"})
              }, 100);
            }
          }),
          utils.extend(fields.expiration_date, {
            disabled:this.isSurplus,read_only:this.isSurplus  || this.forceDisableDueUpgradeDestination,
            listen_for: [
              {
                name: "upd_expiration_date",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
          }),
          utils.extend(fields.maintenance_deadline, {disabled:this.isSurplus,read_only:this.isSurplus || this.forceDisableDueUpgradeDestination}),
          utils.extend(fields.second_number, {disabled:this.DisabledEdit,read_only:this.DisabledEdit || this.forceDisableDueUpgradeDestination}),
          utils.extend(fields.unlimited, {
            disabled:this.DisabledEdit,read_only:this.DisabledEdit || this.forceDisableDueUpgradeDestination,
            on_set_value:(data) =>{
              setTimeout(() => {
              this.queuedBusEmit("upd_license_unlimited",{val: data == "無制限"})
              }, 100);
            }
          }),
          utils.extend(fields.license, {
            disabled:this.DisabledEdit,read_only:this.DisabledEdit || this.forceDisableDueUpgradeDestination,
            listen_for: [
              {
                name: "upd_license_unlimited",
                mode: "disable_and_clean_if_value",
                disable_if_value: false
              }
            ],}),
          utils.extend(fields.applicant_name, {}),  // EDITABLE ON UPGRADE
          utils.extend(fields.management_person_name, {}),  // EDITABLE ON UPGRADE
          utils.extend(fields.comprehensive_contract, {disabled:this.DisabledEdit,read_only:this.DisabledEdit || this.forceDisableDueUpgradeDestination}),
          utils.extend(fields.effective_number, {disabled: true,read_only: true,}),
          utils.extend(fields.remaining_number, {disabled: true,read_only: true,}),

        ],
        col2b: [
          utils.extend(fields.remark, {label_length_4:true}), // EDITABLE ON UPGRADE
          utils.extend(fields.retraction_reason, {
            label_length_4:true,
            disabled : true,
            hide_all : true,
            force_write : false
            })
        ],
        col3: [],
      };
    },
    loadBy() {
      return this.$route.meta.load_by;
    },
  },
  methods: {
    disableValidation(mode){
      this.formFields.col1.forEach(e =>{
        if(e.error_if_blank == true){
          e.ref_field.disabledIsRequired = mode;
          e.ref_field.localRefreshSequecnce++;
        }
      })
      this.formFields.col2.forEach(e =>{
          if(e.error_if_blank == true){
          e.ref_field.disabledIsRequired = mode;
          e.ref_field.localRefreshSequecnce++;
        }
      })
      this.fields_validation_is_disabled = mode;
      this.subTableController.disableValidation(mode)
    },
    queuedBusEmit(id,data){
      queue_bus.push({id,data})
      this.queuedBusRun()
    },
    queuedBusRun(){

      if(queue_bus.length > 0){
        if(timeout_control["bus"]){
          return ;
        }
        timeout_control["bus"] = setTimeout(() => {
          var n = queue_bus.shift()
          bus.$emit(n.id,n.data)
          timeout_control["bus"]  = false;
          this.queuedBusRun()
        }, 50);
      }else{
      }
    },
    singleTimeout(name,ev){
      if(timeout_control[name]){
        clearTimeout(timeout_control[name])
      }
      timeout_control[name] = ev;
    },
    selectUpgradeCertificate(){
      bus.$emit("showCertificateSoftwareLinkedUpgradeModal", {
        seq_id: this.localSeqId,
      });
    },
    onSelectedUpgradeCertificate(data){

      this.$store.state[this.stateCurrentRow]["upgrade_source"] = data.certificate_software_number;
      this.$store.state[this.stateCurrentEditing]["upgrade_source"] = data.certificate_software_number;
      this.fieldList.upgrade_source.ref_field.updateValue(data.certificate_software_number)
      this.fieldList.upgrade_source.ref_field.localRefreshSequecnce++;
      setTimeout(() => {
        this.fieldList.upgrade_source.ref_field.localRefreshSequecnce++;
      }, 500);
    },
    onLinkDevice(){
      return this.$router.push("/certificate_software_linked_devices/list/" + this.certificateSeqId );
    },
    onDelete() {
      bus.$emit("deleteCertificateInformationDetailModal", {
        title: "削除",
        message: "証書情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50",
      });
    },
    onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    AllowSurplusExtraRule(r){
      return (r && r.data
      && ( r.data.status == "廃棄" && (Vue.localStorage.get("userRole")== constants.PERMISSION.SYSTEM_ADMINISTRATOR || Vue.localStorage.get("userRole") == constants.PERMISSION.MAINTENANCE_STAFF)
      || r.data.status == "余剰" ))
    },
    showHistory() {
      this.enableHistoryModal = true;
      setTimeout(() => {
        bus.$emit("showCertificateSoftwareChangeHistoryModal", {
          fk_tab: constants.TABLE_ID.CERTIFICATE_SOFTWARE,
          fk_id: this.localSeqId,
        });
      }, 100);
    },
    onConfirmExecuteProcessConfirmation() {
      var cmn = this.certificateSoftwareNumber;
      if (
        typeof cmn == undefined ||
        cmn == null ||
        cmn == false ||
        cmn.length == 0
      ) {
        cmn = "BY_SEQ_ID::" + this.localSeqId;
      }
      bus.$emit("certificateApplicationConfimationModal", {
        application_mode: "certificate",
        ref_id: cmn,
        modal_is_read_only: true,
        seq_id: this.localSeqId,
        approval_history_id: this.approvalHistoryId || false,
        approval_history_toroku_number: this.approvalHistoryTorokuNumber || false,
      });
    },



    cloneRecord() {
      return this.$router.push({
        name: "page_0060_redirect",
        params: {
          url: "/certificate/clone/" + this.localSeqId,
          message: "コピー ...",
          wait: 50,
        },
      });
    },
    processApprovalApprove() {
      var expiration_date = false;
      if(this.Status == "余剰"){
        var expiration_date = false;
        if(this.$store.state[this.stateCurrentRow]["expiration_date"]  && this.$store.state[this.stateCurrentRow]["expiration_date"].length > 6){
          expiration_date = new Date(this.$store.state[this.stateCurrentRow]["expiration_date"])
        }
        if(this.$store.state[this.stateCurrentEditing]["expiration_date"]  && this.$store.state[this.stateCurrentEditing]["expiration_date"].length > 6){
          expiration_date = new Date(this.$store.state[this.stateCurrentEditing]["expiration_date"])
        }
        if(expiration_date != false && expiration_date.getTime() < (new Date()).getTime()){
          this.$notify({
                title: "ライセンスの有効期限が切れている為、余剰ライセンスへの繰り回しは出来ません",
                type: "error",
                duration: 10000,
              });
          return ;
        }

        // if is lecesingmadoguchi
        // if is status_at_approve_request != 廃棄
        // Show the error
        var userCompany = Vue.localStorage.get("userCompany") || false;
        if(userCompany && userCompany.indexOf("ライセンス管理窓口") == 0){
          if(this.$store.state[this.stateCurrentRow]["status_at_approve_request"] != "廃棄"){
            this.$notify({
              title: "状態が余剰となっていますので使用中に変更してください。",
              type: "error",
              duration: 10000,
            });
            return ;
          }
        }
      }
      return this.processApproval("approve");
    },
    processApprovalCancelBack(mode) {
      if (mode == "yes") {
        console.log("processApprovalCancelBack", mode);
        this.processApproval("cancel");
        this.local_status = false;
        this.ApprovalCancelModeSet(false);
      }
    },
    processApprovalCancelBackReason(mode) {
      if (mode == "yes") {
        console.log("processApprovalCancelBack", mode);
        this.processApprovalReason("cancel");
        this.local_status = false;
        this.ApprovalCancelModeSet(false);
      }
    },
    processFieldStyle(store_key_name, last_changed_fields) {
      if (Array.isArray(last_changed_fields)) {
        last_changed_fields.forEach((e) => {});
      } else {
      }
      this.$store.state[store_key_name] = {};
      if (
        last_changed_fields &&
        last_changed_fields != null &&
        last_changed_fields.length > 0
      ) {
        last_changed_fields.forEach((f) => {
          if (this.showFieldchangedStyle) {
            this.$store.state[store_key_name][f] = ";color:red;";
          }
        });
      }
    },
    processApproval(approve_mode) {
      var changes = {
        seq_id: this.approvalId,
        update_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss"),
      };
      if(approve_mode == "cancel"){
        this.commonSaveInfo(this,this.api_name, {from_edit_form: true },(err)=>{
          if(err){
            //commonSaveInfo already show the error, can ignore it
          }else{
            this.$ajax.post('/approval_history/prepare_to_approve/' + this.approvalId, {changes,approve_mode:approve_mode}, (err, result) => {
              if(err){
                this.$notify({
                  title: 'データの承認に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              }else{
                var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";    
                bus.$emit("notificationAfterCertificateSoftwareApprovalStartedRequest",{
                  message: message,
                  title: "申請が差戻されました",
                  yes_label: "",
                  no_label: "OK",
                  yes_color:"",
                  no_color:"",
                  model_height:"50",
                  model_width: "390px"
                });
              }
            });
          }
        });
      }else{

        var selected_approval_history = this.loadSelectedApprovalHistory()
        if(selected_approval_history.indexOf(this.approvalId) < 0){
          selected_approval_history.push(this.approvalId)
          Vue.localStorage.set('selected_approval_history',JSON.stringify(selected_approval_history))
        }
        bus.$emit("notificationAfterCertificateSoftwareApprovalStartedRequest", {
          message: "",
          title: "申請を確認しました。",
          yes_label: "",
          no_label: "OK",
          yes_color: "",
          no_color: "",
          model_height: "50",
        });
      }
    },
    processApprovalReason(approve_mode) {
      var changes = {
        seq_id: this.approvalId,
        update_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss"),
      };
      if(approve_mode == "cancel"){
        this.commonSaveInfo(this,this.api_name, {from_edit_form: true },(err)=>{
          if(err){
            //commonSaveInfo already show the error, can ignore it
          }else{
            this.$ajax.post('/approval_history/prepare_to_approve/' + this.approvalId, {changes,approve_mode:approve_mode}, (err, result) => {
              if(err){
                this.$notify({
                  title: 'データの承認に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              }else{
                bus.$emit("notificationAfterCertificateSoftwareApprovalStartedRequest",{
                  message: "申請が取戻されました",
                  title: "",
                  yes_label: "",
                  no_label: "OK",
                  yes_color:"",
                  no_color:"",
                  model_height:"50",
                  model_width: "390px"
                });
              }
            });
          }
        });
      }else{

        var selected_approval_history = this.loadSelectedApprovalHistory()
        if(selected_approval_history.indexOf(this.approvalId) < 0){
          selected_approval_history.push(this.approvalId)
          Vue.localStorage.set('selected_approval_history',JSON.stringify(selected_approval_history))
        }
        bus.$emit("notificationAfterCertificateSoftwareApprovalStartedRequest", {
          message: "",
          title: "申請を確認しました。",
          yes_label: "",
          no_label: "OK",
          yes_color: "",
          no_color: "",
          model_height: "50",
        });
      }
    },
    onDeviceEmbeddedInformationAddCheckConfirmStep2(mode) {
        console.log("onDeviceEmbeddedInformationAddCheckConfirmStep2", mode);
        this.read_only = false;
        if(this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" && this.loadBy == "fk_id"){
          // It is in approving proccess, and in this case should not chang ethe status to draft
        }else{
          this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        }
        this.commonSaveInfo(this,this.api_name,{use_transaction:true, from_edit_form: true },(err, saved_data) => {
            if (err) {
              //commonSaveInfo already show the error, can ignore it
            } else {
              if (this.is_new == true) {
                this.saveEditClicked = true;
                this.localSeqId = this.certificateSeqId;
              }
              if(saved_data){
                if(saved_data.show_alert == 1){
                  this.showSurplusAlertMessage = true
                }else{
                  this.showSurplusAlertMessage = false
                }
              }

              bus.$emit("notificationAfterSave", {
                message: "",
                title: "登録情報を下書きに保存しました。",
                yes_label: "",
                no_label: "OK",
                yes_color: "",
                no_color: "",
                model_height: "50",
              });
            }
          }
        );
    },
    onDeviceEmbeddedInformationAddCheckConfirm(mode) {
      if (mode == "yes") {
        if(this.subTableController.save){
          this.subTableController.save((err,data)=>{
            if(err){
               this.$notify({title: err,type: 'error',duration: 10000});
            }else{
              if(data && data.seq_id){
                this.$store.state[this.stateCurrentEditing]["certificate_seq_id"] = data.seq_id;
              }
              this.onDeviceEmbeddedInformationAddCheckConfirmStep2(mode);
            }
          })
        }else{
          this.onDeviceEmbeddedInformationAddCheckConfirmStep2(mode);
        }
      }
    },

    onLocalUpSaveCertificateSoftware(){
      this.form_confirmation = {}
      this.commonValidateFields(this, {}, (error_found) => {
        if (error_found != false) {
          return;
        }
        console.log("onLocalSave")
        bus.$emit("confirmDeviceEmbeddedInformationUpAddCheck",{
          message: "よろしいですか？",
          title: "登録情報を上書保存します。",
          yes_label: "上書保存",
          no_label: "戻る",
          yes_color:"primary",
          no_color:"",
          model_height:"50"
        });
      })
    },
    onDeviceEmbeddedInformationUpAddCheckConfirm(mode){
      if (mode == "yes") {
        console.log("onDeviceEmbeddedInformationUpAddCheckConfirm",mode)
        if(this.subTableController.save && this.forceDisableDueUpgradeDestination != true){
          this.subTableController.save((err,data)=>{
            if(err){
               this.$notify({title: err,type: 'error',duration: 10000});
            }else{
              if(data && data.seq_id){
                this.$store.state[this.stateCurrentEditing]["certificate_seq_id"] = data.seq_id;
              }
              this.onDeviceEmbeddedInformationUpAddCheckConfirmStep2();
            }
          })
        }else{
          this.onDeviceEmbeddedInformationUpAddCheckConfirmStep2();
        }
      };
    },
    onDeviceEmbeddedInformationUpAddCheckConfirmStep2(){
        this.read_only = false;
        this.commonSaveInfo(this,this.api_name, {from_edit_form: true ,overwrite_changed_fields : true, approval_id:this.approvalId },(err,data)=>{
          if(err){
            //commonSaveInfo already show the error, can ignore it
          }else{
             if(data && (  data.show_alert == 1)){
              this.showSurplusAlertMessage = true
            }else{
              this.showSurplusAlertMessage = false
            }
            bus.$emit("notificationAfterSave",{
              message: "",
              title: "登録情報を上書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color:"",
              no_color:"",
              model_height:"50"
            });
          }
        });
    },
    afterTheNotificationAfterSave(mode) {
      if (mode == "no" || mode == "yes") {
        if(this.loadBy != "fk_id"){
          return this.$router.push("/certificate/" + this.localSeqId);
        }
      }
    },
    afterTheNotificationAftercancel(mode) {
      setTimeout(() => {
        return this.$router.push("/approval_history");
      }, 600);
      console.log("afterTheNotificationAftercancel");
    },
    onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    btnCancel() {
      if(this.subTableController.cancel){
        this.subTableController.cancel()
      }
      this.commonValidateFieldsClear(this, () => {});
      this.cancelCurrentSelection(true);
      this.local_status = false;
      this.$store.state[this.stateCurrentEditing]["approval_status"] =""
      this.$store.state[this.stateCurrentRow]["approval_status"] =""
      this.loadFormData();
    },
    onEdit() {
      if(this.isSurplus && this.isNoAdminUserId && this.isExpired){
        this.$notify({clean:true})
        this.$notify({
          title: '有効期限が切れている為、編集する事はできません。',
          // text: err,
          type: 'error',
          duration: 10000
        });
        return
      }
      this.startCompanySelection();
      if(this.subTableController.edit){
        if(this.forceDisableDueUpgradeDestination != true){
          this.subTableController.edit()
        }
      }
      this.commonOnEdit();
      if (this.loadBy == "fk_id" && this.approvalStatus == "申請中") {
        this.fieldList["retraction_reason"].ref_field.$props.data.disabled  = false;
        this.fieldList["retraction_reason"].ref_field.localRefreshSequecnce++;
      }else{
        this.fieldList["retraction_reason"].ref_field.$props.data.disabled  = true;
        this.fieldList["retraction_reason"].ref_field.localRefreshSequecnce++;
      }
    },
    onConfirmExecuteProcess() {
      bus.$emit("certificateApplicationConfimationModal", {
        application_mode: "certificate",
        ref_id: this.certificateSoftwareNumber,
        // approval_status:this.approvalStatus,
        seq_id: this.localSeqId,
        is_surplus: this.isSurplus,
        load_previous_if_exist:true,
        approval_history_id: this.approvalHistoryId || false,
        approval_history_toroku_number: this.approvalHistoryTorokuNumber || false,
      });
    },
    backToList() {
      var certificate_back_to_list = window.sessionStorage.getItem("certificate_back_to_list")
      if((certificate_back_to_list||"").indexOf("/")==0){
        return this.$router.push(certificate_back_to_list);
      }else if (this.loadBy == "fk_id") {
        return this.$router.push({
          name: "page_0050_approval_history_tabs",
          params: {},
        });
      } else {
        return this.$router.push({
          name: "page_0040_certificate_software",
          params: {},
        });
      }
    },
    onLocalSaveCertificateSoftware() {
      this.form_confirmation = {}
      this.commonValidateFields(this, {}, (error_found) => {
        if (error_found != false) {
          return;
        }
        var status = this.getFieldLastValue("status");
        var effective_number = this.getFieldLastValue("effective_number");
        if(status == "廃棄" && effective_number > 0) {
          bus.$emit("confirmUnlinkDevices", {
            message:"機器に紐づいたソフトウェア情報を廃棄します。<br>紐付けを解除してよろしいですか？",
            title: "",
            yes_label: "はい(紐付けを解除して下書保存)",
            no_label: "キャンセル",
            yes_color: "primary",
            no_color: "",
            model_height: "50",
            model_width:"500px"
          });
        }else{
          this.onLocalSaveCertificateSoftwareAfterValudateStatus();
        }
      });
    },
    onConfirmUnlinkDevices(mode){
      if(mode == "yes"){
        this.form_confirmation["confirm_clear_device"] = "yes"
        this.onLocalSaveCertificateSoftwareAfterValudateStatus();
      }
    },
    onLocalSaveCertificateSoftwareAfterValudateStatus() {
      var message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>承認状態が【下書中】となるので、申請が必要になります。</span>";
      //if(this.is_new == true){
        if(this.showapprovalStatus == true) {
        message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>※承認状態が【承認済】のものは【下書中】になります。 </span>";
      }
      if (this.is_new == false) {
        this.saveEditClicked = true;
      }
      console.log("onLocalSave");
      bus.$emit("confirmDeviceEmbeddedInformationAddCheck", {
        message: message,
        title: "登録情報を下書保存します。",
        yes_label: "下書保存",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50",
        model_width: "450px"
      });
    },
    onLocalOnSaveCertificateSoftwareAfterValudateStatus() {
      console.log("onLocalSave")
      bus.$emit("confirmDeviceEmbeddedInformationAddCheck",{
        message: "よろしいですか？",
        title: "登録情報を上書保存します。",
        yes_label: "上書保存",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    hideApprovalCancelSet(flag){
      if (typeof this.fieldList["retraction_reason"] != "undefined"){
        // this.fieldList["retraction_reason"].hide_all = flag;
        if (typeof this.fieldList["retraction_reason"].ref_field != "undefined"){
          this.fieldList["retraction_reason"].ref_field.refresh_hide_force();
        }
      }
    },
    ApprovalCancelModeSet(aflag){
      var bflag = this.hideApprovalcancel;
      if (typeof this.fieldList["retraction_reason"] != "undefined"){
        if(aflag == true){
            // this.fieldList["retraction_reason"].hide_all = bflag;
            this.fieldList["retraction_reason"].force_write = true;
            this.approvalcancelmode = true;
        }else{
            // this.fieldList["retraction_reason"].hide_all = true;
            this.fieldList["retraction_reason"].force_write = false;
            this.approvalcancelmode = false;
        }
        if (typeof this.fieldList["retraction_reason"].ref_field != "undefined"){
        this.fieldList["retraction_reason"].ref_field.refresh_hide_force();
        }
      }
    },
    processApprovalCancel() {
      console.log("processApprovalCancel");
      this.ApprovalCancelModeSet(true);
    },
    onapprovalSaveDevEmbedded(){    
      bus.$emit("confirmDeviceEmbeddedInformationAddcancel", {
        message: "よろしいですか？",
        title: "申請を差戻します。",
        yes_label: "差戻",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50",
      });
    },
    onapprovalSaveDevEmbeddedReason(){    
      bus.$emit("confirmDeviceEmbeddedInformationAddcancelReason", {
        message: "よろしいですか？",
        title: "申請を取戻します。",
        yes_label: "取戻",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50",
      });
    },
    approvalCancelbtn(){
      this.ApprovalCancelModeSet(false);
    },
    prepareCompanySelection(
      companies,
      department_and_team,
      company_field,
      department_field,
      team_field,
      company_field_name,
      department_field_name
    ) {


      var selected_company = false;
      var selected_department = false;
      company_field.page_controller_setup({
        on_select: (_selected_company) => {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq( _.map( _.filter(department_and_team || [], (d) => { return d.company == selected_company; }) || [], "department" ) || []
            );
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true,
            });
          }
        },
      });
      department_field.page_controller_setup({
        on_select: (_selected_department) => {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return (
                    d.company == selected_company &&
                    d.department == selected_department
                  );
                }) || [],
                "team"
              ) || []
            );
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: true,
            });
          }
        },
      });

      company_field.page_controller_msg({
        cmd: "set_options",
        options:  _.clone(companies),
      });
      company_field.page_controller_msg({ cmd: "enable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      setTimeout(
        () => {
          department_field.page_controller_msg({ cmd: "enable_if_data" });
          team_field.page_controller_msg({ cmd: "enable_if_data" });

          selected_company = this.$store.state[this.stateCurrentRow][company_field.id];
          selected_department = this.$store.state[this.stateCurrentRow][department_field.id];
          if (selected_company && selected_company.length > 0) {
            var departments = _.uniq(
              _.map( _.filter(department_and_team || [], (d) => { return d.company == selected_company; }) || [], "department" ) || []
            );
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: false,
            });
            department_field.page_controller_msg({ cmd: "enable" });
            if (selected_department && selected_department.length > 0) {
              var teams = _.uniq(
                _.map(
                  _.filter(department_and_team || [], (d) => {
                    return (
                      d.company == selected_company &&
                      d.department == selected_department
                    );
                  }) || [],
                  "team"
                ) || []
              );
              team_field.page_controller_msg({
                cmd: "set_options",
                options: teams,
                reset: false,
              });
            }
          }

          if(this.isSurplus){
            setTimeout(() => {
              // var departments = _.uniq(_.map(_.filter(department_and_team || [], (d) => {return d.company == selected_company;}) || [],"department") || []);
              // departments.unshift("");
              department_field.page_controller_msg({ cmd: "enable" });
              // department_field.page_controller_msg({ cmd: "set_value", val: "" });
              // team_field.page_controller_msg({ cmd: "set_value", val: "" });
              // team_field.page_controller_msg({ cmd: "disable" });
              // department_field.page_controller_msg({
              //   cmd: "set_options",
              //   options: departments,
              //   reset: true,
              // });
            }, 500);
          }
        },
        this.is_new ? 100 : 500
      );
    },
    startCompanySelection(){
      if(this.company_selection_started == true){
        return;
      }
      this.company_selection_started  = true;
      if (true) {
        var temp_fields = this.installedFieldList;
        // Load the companies
        this.$ajax.post_cached_queued( "/master_company/list_company_name", {}, (err, _companies) => {
            if (err) {
              this.$notify({
                title: "所管会社のデータが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000,
              });
              return;
            }
            var companies = [""];
            _companies.forEach((c) => {
              companies.push(c.val);
            });
            // Load the departments and teams
            this.$ajax.post_cached_queued(
              "/master_belongs/list_team_and_department",
              {},
              (err, department_and_team) => {
                if (err) {
                  this.$notify({
                    title: "部署・チームのデータの読込に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000,
                  });
                  return;
                }
                this.prepareCompanySelection(
                  _.clone(companies),
                  _.clone(department_and_team),
                  temp_fields.company,
                  temp_fields.licensed_department,
                  temp_fields.license_jurisdiction_team,
                  "company",
                  "department"
                );
                if (this.$route.params.seq_id == "new") {
                  var default_company = Vue.localStorage.get(
                    temp_fields.company.default_from_local_storage
                  );
                  if (default_company != constants.COMPANY.ALL) {
                    setTimeout(
                      () => {
                        var default_deparment = Vue.localStorage.get(
                          temp_fields.licensed_department
                            .default_from_local_storage
                        );
                        var default_team = Vue.localStorage.get(
                          temp_fields.license_jurisdiction_team
                            .default_from_local_storage
                        );
                        temp_fields.company.page_controller_msg({
                          cmd: "set_value",
                          val: default_company,
                        });
                        temp_fields.licensed_department.page_controller_msg({
                          cmd: "set_value",
                          val: default_deparment,
                        });
                        temp_fields.license_jurisdiction_team.page_controller_msg(
                          { cmd: "set_value", val: default_team }
                        );
                      },
                      this.is_new ? 300 : 1000
                    );
                  }
                }
              }
            );
          }
        );
      }
    },

    loadFormData(){
      mdebug("page_0040_certificate_software_detail mounting");
      this.approvalHistoryBulkTorokuNumberQty = 0;
      this.isExpired = false;
      this.fieldList["retraction_reason"].hide_all = true;
      if (this.loadBy == "certificate_software_number") {
        // link_from_device_embedded_software_to_certificate_software_number step3
        var certificate_software_number = this.$route.params.certificate_software_number;
        this.$ajax.post("/" + this.api_name + "/get_by_ref_id/" + certificate_software_number,{ ref_id: certificate_software_number },(err, result) => {
            if (err) {
              this.$notify({
                title: "データの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000,
              });
            }
            this.localSeqId = result.data.seq_id;
            this.$store.state[this.stateCurrentRow] = result.data;
            if(this.subTableController){
              if (result && result.data && result.data.certificate_seq_id && result.data.certificate_seq_id > -1) {
              this.subTableController.load_data(result.data.certificate_seq_id)
              }else{
                this.subTableController.load_data("new")
              }
            }
            if (typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number" &&
              isNaN(this.$store.state[this.stateCurrentRow].approval_history_toroku_number) == false) {
              this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id;
              this.approvalHistoryTorokuNumber = this.$store.state[this.stateCurrentRow].approval_history_toroku_number;
              if (this.approvalHistoryId == -200) {
                this.approvalHistoryTorokuNumber;
              }
            }
            if(result && result.data && (  result.data.disable_validation == 1 )){
              this.disableValidation(true);
            }
            if(result && result.data && result.data.status){
              this.original_status = result.data.status || false;
            }

            if(this.AllowSurplusExtraRule(result)){
              this.allowSurplus = true;
            }else{
              this.allowSurplus = false;
            }
            if(result && result.data && (  result.data.status == "余剰" )){
              this.isSurplus = true;
            }else{
              this.isSurplus = false;
            }
            if(result && result.data && ( result.data.approval_status == "承認済")){
              this.isApproved = true;
            }else{
              this.isApproved = false;
            }
            if(result && result.data && (  result.data.show_alert == 1)){
              this.showSurplusAlertMessage = true
            }else{
              this.showSurplusAlertMessage = false
            }

            this.commonSetStyleForChangedFields(result.data);
            mdebug("LOAD DATA", { err, result });
          }
        );
      } else if (this.loadBy == "fk_id") {
        this.is_new = false;
        this.localSeqId = this.$route.params.fk_id;
        this.approvalId = this.$route.params.approval_id;
        this.$ajax.post("/" + this.api_name + "/get/" + this.$route.params.fk_id,{ fk_id: this.$route.params.fk_id },(err, result) => {
            if (err) {
              this.$notify({
                title: "データの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000,
              });
            }
            this.localSeqId = result.data.seq_id;
            this.$store.state[this.stateCurrentRow] = result.data;
            this.fieldList["retraction_reason"].hide_all = this.$store.state[this.stateCurrentRow].approval_status == "承認済";
            if (typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number" && isNaN(this.$store.state[this.stateCurrentRow].approval_history_toroku_number) == false) {
              this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id;
              if(this.approvalHistoryId > 0){
                this.approvalId = this.approvalHistoryId
              }
              this.approvalHistoryTorokuNumber = this.$store.state[this.stateCurrentRow].approval_history_toroku_number;
              if (this.approvalHistoryId == -200) {
                this.approvalHistoryTorokuNumber;
              }
            }
            if(this.subTableController){
              if (result && result.data && result.data.certificate_seq_id && result.data.certificate_seq_id > -1) {
              this.subTableController.load_data(result.data.certificate_seq_id)
              }else{
                this.subTableController.load_data("new")
              }
            }

            if(result && result.data && (  result.data.disable_validation == 1 )){
              this.disableValidation(true);
            }
            if(result && result.data && result.data.status){
              this.original_status = result.data.status || false;
            }
            if(this.AllowSurplusExtraRule(result)){
              this.allowSurplus = true;
            }else{
              this.allowSurplus = false;
            }
            if(result && result.data && (  result.data.status == "余剰" )){
              this.isSurplus = true;
            }else{
              this.isSurplus = false;
            }
            if(result && result.data && ( result.data.approval_status == "承認済")){
              this.isApproved = true;
            }else{
              this.isApproved = false;
            }

            if( this.isSurplus == false && result && result.data && result.data.expiration_date){
              var today = moment(new Date())
              var exp_date = moment(result.data.expiration_date)

              var diff = exp_date.diff(today, 'days')
              if(diff < 0){
                this.allowSurplus = false;
              }
            }
            if(result && result.data && result.data.expiration_date){
              var exp_date = moment(result.data.expiration_date)
              var deadline_alert = result.data.deadline_alert || "無"
              var diff = exp_date.diff(today, 'days')
              if(deadline_alert == "有" && diff < 0){
                this.isExpired = true;
              }
            }
            if(result && result.data && (  result.data.show_alert == 1)){
              this.showSurplusAlertMessage = true
            }else{
              this.showSurplusAlertMessage = false
            }
            this.approvalHistoryBulkTorokuNumberQty = result.data.approval_history_bulk_toroku_number_qty || 0;
            this.commonSetStyleForChangedFields(result.data);
            mdebug("LOAD DATA", { err, result });
          }
        );
      } else if (this.loadBy == "clone") {
        this.startCompanySelection();
        this.is_new = true;
        this.localSeqId = Number.MAX_SAFE_INTEGER;
        this.$ajax.post(
          "/" + this.api_name + "/get/" + this.$route.params.seq_id,
          {},
          (err, result) => {
            if (err) {
              this.$notify({
                title: "データの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000,
              });
            }
            // result.data.seq_id = Number.MAX_SAFE_INTEGER;
            // result.data.device_control_number = "";
            this.$store.state[this.stateCurrentRow] = {};
            this.$store.state[this.stateCurrentEditing] = {};
            Object.keys(result.data).forEach((k) => {
              var value = result.data[k];
              if (k == "seq_id") {
                this.$store.state[this.stateCurrentRow][k] =
                  Number.MAX_SAFE_INTEGER;
                // this.$store.state[this.stateCurrentEditing][k] = Number.MAX_SAFE_INTEGER;
              } else if (k == "certificate_software_number") {
                this.$store.state[this.stateCurrentRow][k] = "";
                this.$store.state[this.stateCurrentEditing][k] = "";
              } else if (k == "approval_status_flag" || k == "effective_number") {
                this.$store.state[this.stateCurrentRow][k] = 0;
                this.$store.state[this.stateCurrentEditing][k] = 0;
              } else if(k == "approval_status") {
                this.$store.state[this.stateCurrentRow][k] = "";
                this.$store.state[this.stateCurrentEditing][k] = "";
              } else {
                this.$store.state[this.stateCurrentRow][k] = value;
                this.$store.state[this.stateCurrentEditing][k] = value;
              }
            });
            this.Status = "使用中";

            this.commonSetStyleForChangedFields(result.data);
            setTimeout(() => {
              this.$store.state[this.stateIsEditingNew] = true;
              this.read_only = false;
              this.is_new = true;
              if(this.subTableController){
                this.subTableController.load_data("new")
              }
            }, 300);
            this.commonEditDeleteCmdHandler(this);
          }
        );
      } else {
        this.commonLoadRecord({},(err, result) => {
          if (
            typeof this.$store.state[this.stateCurrentRow].approval_history_id =="number" && 
            isNaN(this.$store.state[this.stateCurrentRow].approval_history_toroku_number) == false
          ) {
            this.approvalHistoryId = this.$store.state[
              this.stateCurrentRow
            ].approval_history_id;
            this.approvalHistoryTorokuNumber = this.$store.state[
              this.stateCurrentRow
            ].approval_history_toroku_number;
            if (this.approvalHistoryId == -200) {
              this.approvalHistoryTorokuNumber;
            }
          }
         // if (this.isApproverUserId == true) {
          //  return this.disabled == "management_person_name";
        //  }
          if (this.$route.params.seq_id == "new") {
            this.Deadline_Alert = "無";
            this.Comprehensive_contract = "無";
            this.Downgrade = "無";
            this.Status = "使用中";
            setTimeout(() => {
              this.startCompanySelection();
            }, 10);
          }else{
            if(result && result.data && (  result.data.disable_validation == 1 )){
              this.disableValidation(true);
            }
            if(result && result.data && result.data.status){
              this.original_status = result.data.status || false;
            }
            if(this.AllowSurplusExtraRule(result)){
              this.allowSurplus = true;
            }else{
              this.allowSurplus = false;
            }
            if(result && result.data && (  result.data.status == "余剰" )){
              this.isSurplus = true;
              this.fieldList.product_key.ref_field.localDisabled = true
            }else{
              this.isSurplus = false;
            }
            if(result && result.data && ( result.data.approval_status == "承認済")){
              this.isApproved = true;
            }else{
              this.isApproved = false;
            }
            if( this.isSurplus == false && result && result.data && result.data.expiration_date){
              var today = moment(new Date())
              var exp_date = moment(result.data.expiration_date)

              var diff = exp_date.diff(today, 'days')
              if(diff < 0){
                this.allowSurplus = false;
              }
            }
            if(result && result.data && result.data.expiration_date){
              var exp_date = moment(result.data.expiration_date)
              var deadline_alert = result.data.deadline_alert || "無"
              var diff = exp_date.diff(today, 'days')
              if(deadline_alert == "有" && diff < 0){
                this.isExpired = true;
              }
            }
          }
          if (result && result.data && result.data.upgrade_destination && (result.data.upgrade_destination||"").length > 0) {
            this.forceDisableDueUpgradeDestination = true;
          }else{
            this.forceDisableDueUpgradeDestination = false;
          }
          if(this.subTableController){
            if (result && result.data && result.data.certificate_seq_id && result.data.certificate_seq_id > -1) {
            this.subTableController.load_data(result.data.certificate_seq_id)
            }else{
              this.subTableController.load_data("new")
            }
          }
          if(result && result.data && (  result.data.show_alert == 1)){
            this.showSurplusAlertMessage = true
          }else{
            this.showSurplusAlertMessage = false
          }
          this.commonEditDeleteCmdHandler(this);
        });
      }
    }
  },
  mounted() {
    this.loadFormData();
    this.DisabledEdit = this.isApproverUserId == true;

  },
  beforeDestroy() {
    this.approvalHistoryBulkTorokuNumberQty = 0;
    var store_style = (this.$store.state[
      this.stateCurrentRow.replace("current_row", "current_field_style")
    ] = {});
  },
  beforeMount() {},
};
</script>
<style scoped>
.surplus_msg{
  color:red;
  margin: 20px 0px 20px -10px;
  font-weight: bold;
}
.status_field{
  border: solid #337ab7 1px;
  width: 90px;
  padding-left: 4px;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
}
.on_local_save_certificate_software{
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: -10px;
}
.btn_cancel_btn{
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #a6a6a6;
}
.on_edit_btn{
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  margin-right:-10px;
}
.process_approval_approve_btn{
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #92d050;
  border-color: #92d050;
}
.process_approval_cancel_btn{
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #ff7c80;
  border-color: #ff7c80;
}
.on_confirm_execute_process_btn{
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #92d050;
  border-color: #92d050;
}
.clone_record_btn{
min-width: 100px; width: 7%; float: right; margin-right: 10px
}
.show_device_btn{
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  _background: #a6a6a6;
  _border-color: #a6a6a6;
}
.show_history_btn{
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #a6a6a6;
  border-color: #a6a6a6;
}
.bottom_tab {
  width: 100%;
  margin-bottom: 20px;
}
.bottom_tab th {
  font-size: 12px;
}
.bottom_tab td input {
  border: solid #337ab7 1px;
  width: 98%;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
  padding-left: 4px;
}
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// page_0040_certificate_software_detail.vue?a65a6454